export default __webpack_public_path__ + "static/20-d0b9c0003af452b3df34ffcd148cde4f.jpg";